import axios from 'axios'
import config from './config'
import {localStorageCache,toLoginPage} from '@/assets/js/utils'
// import {localStorageCache} from '../assets/js/utils'
//
// 因为params是添加到url的请求字符串中的，用于get请求。 需要 Qs
// 而data是添加到请求体（body）中的， 用于post请求。



class Http {
  constructor(config) {
    this.axios = axios.create({
      baseURL: config.URL
    })
    this.URL = config.URL
    this.axios.defaults.headers['Content-Type'] = 'application/json'
    this.interceptorsRequest() // 请求拦截器
    this.interceptorsResponse() // 响应拦截器
  }

  interceptorsRequest() { // 请求拦截器
    this.axios.interceptors.request.use((config) => {
      config.headers['token'] = localStorageCache.fetch('token') || '' // 用户登录的凭证
      return config
    }, function (error) {
      // Toast('网络出错 稍后再试')
      console.log('&错误信息&',error,)
      return Promise.reject(error)
    })
  }

  interceptorsResponse() { // 响应拦截器
    this.axios.interceptors.response.use((response) => {
      var { data, headers } = response;
      if(headers.http_x_auth_token !== undefined){
        localStorageCache.save('token', headers.http_x_auth_token)
      }
      if (data.code == 200) {
        return data;
      } else if (data.code == 201) {
        console.log(data, '未登录')
        localStorageCache.remove('token')
        toLoginPage()//本地注释
      } else { 
        console.log(data, '错误信息')
        return data;
      }
    }, function (error) {
      console.log(error, '&网络异常&');
      return Promise.reject(error)
    })
  }

  get(url, params = {}) {
    return this.axios({
      method: 'get',
      url,
      params,
      timeout: 10000
    })
  }

  post(url, data = {}) {
    return this.axios({
      method: 'post',
      url,
      data,
      timeout: 10000
    })
  }

  put(url, data = {}) {
    return this.axios({
      method: 'put',
      url,
      data,
      timeout: 10000
    })
  }

}

export const http = new Http(config)